<script lang="ts" setup>
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();
const config = useRuntimeConfig();
const { sendToParent } = useParentMessaging();

const headerIconPath = computed(() => config.public.headerIconPath || 'images/icon_chat_header.png');

const isExtend = () => {
  let windowExtend = !chatStore.windowExtend;
  let chatMode = "largeChat";
  if (!windowExtend) {
    chatMode = "openChat";
  }

  document.body.style.display = "none";
  sendToParent({ mode: chatMode });
  setTimeout(() => {
    chatStore.windowExtend = windowExtend;
    document.body.style.display = "block";
  }, 200);
}

const toggleDeepResearchPanel = () => {
  if (!chatStore.deepResearch.isActive) {
    return;
  }
  chatStore.toggleDeepResearch();
};

const isResetting = ref(false);
const resetChat = async () => {
  if (isResetting.value) {
    return;
  }

  isResetting.value = true;
  try {
    await chatStore.restartSession({ preserveWindowExtend: true, preserveMessages: true });
  } finally {
    isResetting.value = false;
  }
};

const isClosed = () => {
  let chatMode = "largeIcon";
  if (!chatStore.isDspStartChat) {
    chatMode = "smallIcon";
  }

  document.body.style.display = "none";
  sendToParent({ mode: chatMode });
  setTimeout(() => {
    chatStore.windowClosed = !chatStore.windowClosed
    document.body.style.display = "block";
  }, 200);
}

const openNewWindow = () => {
  // forcedMode があれば引き継ぐ（特別モード直接起動の場合）
  const modeQuery = chatStore.forcedMode
    ? `&mode=${encodeURIComponent(chatStore.forcedMode)}`
    : '';

  // 別タブで開く
  window.open(`${config.public.cdnUrl}?isNewWindow=true${modeQuery}`, '_blank');

  isClosed();
}
</script>

<template>
  <div class="aichat-header flex justify-center items-center h-[45px] bg-white p-1 z-50">
    <div class="absolute left-2 flex justify-center items-center gap-3">
      <clientOnly>
        <VTooltip :delay="10" v-if="($device.isDesktop || $device.isTablet) && !chatStore.isNewWindow">
          <button type="button" @click="openNewWindow" class="hidden sm:!flex" :aria-label="$t('newWindow')">
            <Icon name="ooui:new-window-rtl" class="!block" size="20px" />
          </button>

          <template #popper>
            {{ $t('newWindow') }}
          </template>
        </VTooltip>
      </clientOnly>
    </div>
    <img :src="chatStore.createUrl(true, headerIconPath)" :alt="config.public.title" title="" />
    <button type="button"
      class="font-semibold tracking-[2.7px] p-[10px] focus:outline-none bg-transparent border-0 cursor-pointer"
      @click="resetChat">
      {{ config.public.title }}
    </button>
    <div class="absolute right-2 flex justify-center items-center gap-3">
      <ClientOnly>

        <LanguageMenu />
        <!-- <VTooltip :delay="10" v-if="chatStore.deepResearch.isActive">
          <button type="button" @click="toggleDeepResearchPanel" class="relative flex"
            :aria-label="$t(chatStore.deepResearch.isPanelOpen ? 'deepResearch.closePanel' : 'deepResearch.openPanel')">
            <Icon name="mdi:flask-outline" size="20px"
              :class="{ '!text-[#194593]': chatStore.deepResearch.isPanelOpen }" />
            <span v-if="chatStore.deepResearch.hasUnseenUpdates"
              class="absolute -top-1 -right-1 inline-flex h-2.5 w-2.5 rounded-full bg-red-500"></span>
          </button>

          <template #popper>
            {{ chatStore.deepResearch.isPanelOpen ? $t('deepResearch.closePanel') : $t('deepResearch.openPanel') }}
          </template>
        </VTooltip> -->
        <VTooltip :delay="10" v-if="($device.isDesktop || $device.isTablet) && !chatStore.isNewWindow">
          <button type="button" @click="isExtend" class="hidden sm:!flex" :aria-label="$t('fullScreen')">
            <Icon name="material-symbols:fullscreen" size="20px" />
          </button>

          <template #popper>
            {{ $t('fullScreen') }}
          </template>
        </VTooltip>
        <VTooltip :delay="10" v-if="!chatStore.isNewWindow">
          <button type="button" @click="isClosed" class="flex" :aria-label="$t('close')">
            <Icon name="material-symbols:cancel-outline" class="!block" size="20px" />
          </button>

          <template #popper>
            {{ $t('close') }}
          </template>
        </VTooltip>
      </ClientOnly>
    </div>
  </div>
</template>
